import { EntitySharing, EntityType, ResolvedEntity } from '@frontend/common';
import React from 'react';

import { PlatformObjectBadge, PlatformObjectBadgeProps } from './platform-object-badge.component';

export type PlatformResolvedEntityBadgeProps = Omit<PlatformObjectBadgeProps, 'id' | 'entityType' | 'display' | 'foreign'> & {
    entity: ResolvedEntity;
    /** Overrides `entity.entity_type` when the list column forces a type (e.g. categories). */
    entityType?: EntityType | string;
    /** Overrides `entity.name` when a custom label is needed. */
    display?: string;
    /**
     * Parent row `shared` — accepted for call-site compatibility; foreign rights use `entity.foreign`
     * + resolve, not account tooltip props.
     */
    parentShared?: EntitySharing | null;
};

/**
 * PlatformObjectBadge wired from a ResolvedEntity so `foreign` / display always pass through.
 * Prefer this over hand-rolling id/display/foreign whenever the source is a ResolvedEntity.
 */
export const PlatformResolvedEntityBadge = ({ entity, entityType, display, parentShared: _parentShared, ...rest }: PlatformResolvedEntityBadgeProps) => (
    <PlatformObjectBadge
        id={entity.entity_id}
        entityType={entityType ?? entity.entity_type}
        display={display ?? entity.name}
        foreign={entity.foreign}
        {...rest}
    />
);
